import { Component, Input } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

@Component({
  selector: 'pl-sales-orders-summary',
  standalone: true,
  imports: [CommonModule,DatePipe],
  templateUrl: './sales-orders-summary.component.html',
  styleUrls: ['./sales-orders-summary.component.scss']
})
export class SalesOrdersSummaryComponent {
  @Input() format: 'short' | 'medium' | 'long' | 'custom' | 'iso' = 'long';
  
  currentDate: Date = new Date();
  totalSales: number = 0;
  totalOrders: number = 0;
  averageOrderValue: number = 0;
  
  constructor(private datePipe: DatePipe) {}

  getFormattedDate(): string {
    switch (this.format) {
      case 'short':
        return this.datePipe.transform(this.currentDate, 'short') || '';
      case 'medium':
        return this.datePipe.transform(this.currentDate, 'medium') || '';
      case 'custom':
        return this.datePipe.transform(this.currentDate, 'EEEE, MMMM d, y') || '';
      case 'iso':
        return this.datePipe.transform(this.currentDate, 'yyyy-MM-dd') || '';
      case 'long':
      default:
        return this.datePipe.transform(this.currentDate, 'fullDate') || '';
    }
  }

  // Alternative method using native JavaScript
  getCustomFormattedDate(): string {
    const options: Intl.DateTimeFormatOptions = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    };
    return this.currentDate.toLocaleDateString('en-US', options);
  }

  // Method to refresh the date (useful for real-time updates)
  refreshDate(): void {
    this.currentDate = new Date();
  }
}
